import { gql } from '@apollo/client';

export const SearchQuery = gql`
  query Search($searchTerm: String!) {
    searchCampaigns(searchTerm: $searchTerm) {
      id
      companyId
      shortId
      name
      exactMatch
      updatedAt
      brandName
      status
      companyName
    }
    searchCompanies(searchTerm: $searchTerm) {
      id
      name
      exactMatch
      updatedAt
    }
  }
`;
